/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".outerCont[_ngcontent-%COMP%]{line-height:16px}.outerCont[_ngcontent-%COMP%]   .listItem[_ngcontent-%COMP%]{margin-right:5px;display:block;padding:1px 5px;margin-bottom:5px}.outerCont[_ngcontent-%COMP%]   .listItem[_ngcontent-%COMP%]   .closeIcon[_ngcontent-%COMP%]{margin-right:1px;cursor:pointer;color:#60bfd4}"];
export { styles as styles };
